import { render, staticRenderFns } from "./TrendRank.vue?vue&type=template&id=328e08c6&scoped=true"
import script from "./TrendRank.vue?vue&type=script&lang=js"
export * from "./TrendRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328e08c6",
  null
  
)

export default component.exports